import React from 'react';

import Text from 'components/shared/Typography/Text';

function NewPage() {
  return <Text size="large">No Data</Text>;
}

export default NewPage;
